import { TypedActionTree, TypedGetterTree, TypedMutationTree } from '../../CustomFundamentalStoreContracts';
import { IRootState } from '../../root/rootTypes';
import { VuexModuleFactory } from '../../VuexModuleFactory';
import { IDisplayActions, IDisplayGetters, IDisplayMutations, IDisplayState } from './displayTypes';

const menuMutations: TypedMutationTree<IDisplayMutations, IDisplayState> = {
  SET_CLOSE_OVERLAY: (state, payload) => {
    state.closeOverlay = payload;
  },
  SET_IS_MOBILE: (state, payload) => {
    state.isMobile = payload;
  },

  SET_MODAL_STATE: (state, payload) => {
    state.modalsModel[payload.modalType] = payload.state;
  },
};

const menuActions: TypedActionTree<IDisplayActions, IDisplayMutations, IDisplayGetters, IDisplayState, IRootState> = {
  closeOverlayMenu: async ({ commit, state }) => {
    if (state.closeOverlay) {
      state.closeOverlay();
    }
    commit('SET_CLOSE_OVERLAY', undefined);
  },
  registerOverlayMenu: async ({ commit }, callback) => {
    commit('SET_CLOSE_OVERLAY', callback);
  },
  setIsMobile: ({ commit, state }, isMobile) => {
    if (state.isMobile === isMobile) {
      return;
    }
    commit('SET_IS_MOBILE', isMobile);
  },
  unregisterOverlayMenu: async ({ commit }) => {
    commit('SET_CLOSE_OVERLAY', undefined);
  },
};

const menuGetters: TypedGetterTree<IDisplayGetters, IDisplayState, IRootState> = {
  isOverlayOpen: (state) => !!state.closeOverlay,
  isMobile: (state) => state.isMobile,
};

const menuState: IDisplayState = {
  closeOverlay: undefined,
  isMobile: false,
  modalsModel: {
    default: { isOpen: false },
    message: {
      isOpen: false,
    },
  },
};

export default new VuexModuleFactory<IDisplayState, IRootState, IDisplayActions, IDisplayMutations, IDisplayGetters>(
  'menu',
  menuState,
  { actions: menuActions, getters: menuGetters, mutations: menuMutations },
);
